function initUnconfiguredForSearchResults(options, $, $ajax) {
    const $toggleUnitFomCompared = options.toggleUnitFomComparedBtn
        ? $(options.toggleUnitFomComparedBtn)
        : $('.comparedWrap > .unitsListForFacilityActions li').not('.browseList');

    const config = {
        compareCounter: '.nCompare',
        numberOfCompared: $('#compareUnitsData').data('count'),
        texts: {
            warning: $('#compareUnitsData').data('text-warning'),
        },
        disableFlyingIcon: false,
        onlyButtonClick: false,
        limitReached: false,
        maximumUnitsLimit: 30,
        onAdd: () => {},
        onRemove: () => {},
    };

    let currentlyActiveToggler = null;

    $.extend(config, options);

    if (!config.onlyButtonClick) {
        toggleListSlideEvent();
    } else {
        check($toggleUnitFomCompared.data('unit-id')).then((data) => {
            data === true // eslint-disable-line no-unused-expressions
                ? $toggleUnitFomCompared.addClass('active')
                : $toggleUnitFomCompared.removeClass('active');

            toggleTitleText($toggleUnitFomCompared);
        });
    }

    if (!config.disableFlyingIcon) {
        initFlyingIconAnimation();
    }

    $toggleUnitFomCompared.on('click', toggleFromCompared);

    function toggleFromCompared(event) {
        const $unitListToggler = $(event.target).parents().siblings('.compareToggle');
        const unitId = $(event.target).data('unit-id');

        if (!$(event.target).hasClass('active')) {
            add(unitId);
            config.numberOfCompared += 1;
        } else {
            remove(unitId);
            config.numberOfCompared -= 1;
        }

        $(event.target).toggleClass('active');

        if (!config.onlyButtonClick) {
            toggleHasComparedClass($unitListToggler);
        } else {
            toggleTitleText($toggleUnitFomCompared);
        }

        updateCounters(config.compareCounter, config.numberOfCompared);
    }

    function add(unitId) {
        if (config.numberOfCompared >= config.maximumUnitsLimit) {
            showLimitReachedDialog(config.texts);

            return;
        }

        $ajax($('#compareUnitsData').data('url-add'), { unitId }).then(() => {
            config.onAdd();
        });
    }

    function remove(unitId) {
        $ajax($('#compareUnitsData').data('url-remove'), { unitId }).then(() => {
            config.onRemove();
        });
    }

    function check(unitId) {
        return $ajax($('#compareUnitsData').data('url-check'), { unitId });
    }

    function toggleTitleText($btn) {
        if ($btn.hasClass('active')) {
            $btn.attr('title', $btn.data('remove-text'));
        } else {
            $btn.attr('title', $btn.data('add-text'));
        }
    }

    function initFlyingIconAnimation() {
        $('.comparedWrap > .unitsListForFacilityActions li:not(.active)').on('click', function unitsListForFacilityClick() {
            const $unitListToggler = $(this).parents().siblings('.compareToggle');
            const destinationIcon = $('.utilityIconNew .moveToCompare')[0];
            flyIcon($unitListToggler, $(destinationIcon));
        });
    }

    function toggleListSlideEvent() {
        document.querySelectorAll('.compareToggle').forEach((toggler) => {
            toggler.addEventListener('click', () => {
                slideUnitList(toggler);
            });
        });

        function slideUnitList(element) {
            if (!element.classList.contains('active')) {
                closeOtherUnitLists();
                currentlyActiveToggler = element;

                addClickAwayListener();
            } else {
                removeClickAwayListener();
            }

            slideList(element);
        }
    }

    function closeOtherUnitLists() {
        document.querySelectorAll('.compareToggle.active').forEach((toggler) => {
            slideList(toggler);
        });
    }

    function slideList(toggler) {
        $(toggler).siblings('.unitsListForFacilityActions').slideToggle(100);
        $(toggler).toggleClass('active');
    }

    function clickAwayListener(event) {
        if (!currentlyActiveToggler.contains(event.target)) {
            slideList(currentlyActiveToggler);
            removeClickAwayListener();
        }
    }

    function addClickAwayListener() {
        document.addEventListener('click', clickAwayListener);
    }

    function removeClickAwayListener() {
        document.removeEventListener('click', clickAwayListener);
    }

    function toggleHasComparedClass($listToggler) {
        const hasCompared = $listToggler.siblings('ul').find('li.active').length > 0;

        if (hasCompared) {
            $listToggler.addClass('compared');
        } else {
            $listToggler.removeClass('compared');
        }
    }

    function updateCounters(counters, count) {
        $('#compareUnitsData').data('count', count);
        $(counters).fadeOut('50', () => { $(counters).text(count).fadeIn('50'); });
    }

    function flyIcon($flyingIcon, $destinationIcon) {
        if ($flyingIcon) {
            const $flyingIconClone = $flyingIcon.clone()
                .offset({
                    top: $flyingIcon.offset().top,
                    left: $flyingIcon.offset().left,
                })
                .css({
                    opacity: '0.5',
                    position: 'absolute',
                    'z-index': '100',
                })
                .appendTo($('body'))
                .animate({
                    top: $destinationIcon.offset().top + 10,
                    left: $destinationIcon.offset().left + 10,
                }, 600, 'swing');

            $flyingIconClone.animate({ width: 0, height: 0 }, function flyingIconCloneAnimate() {
                $(this).detach();
            });
        }
    }

    function showLimitReachedDialog(texts) {
        $('.maxLimitAlert')
            .dialog({
                draggable: false,
                modal: true,
                width: 300,
                height: 180,
                autoOpen: false,
                title: texts.warning,
                buttons: {
                    Ok() {
                        $(this).dialog('close');
                    },
                },
            })
            .dialog('open')
            .show();
    }
}

function unconfiguredUpdateCompareView(options, $) {
    const $unitItem = $(`.comparedWrap > .unitsListForFacilityActions > li[data-unit-id="${options.unitId}"]`);
    const $unitListToggler = $unitItem.parents().siblings('.compareToggle');
    const $compareCounter = $('.nCompare');
    let hasCompared = false;

    if (options.removed) {
        $unitItem.removeClass('active');
    } else {
        $unitItem.addClass('active');
    }

    hasCompared = $unitListToggler.siblings('ul').find('li.active').length > 0;

    if (hasCompared) {
        $unitListToggler.addClass('compared');
    } else {
        $unitListToggler.removeClass('compared');
    }

    if (options.numberOfCompared) {
        $compareCounter.fadeOut('50', () => { $compareCounter.text(options.numberOfCompared).fadeIn('50'); });
    } else {
        $compareCounter.hide();
        $compareCounter.text('');
    }
}

const initComparedForSearchResults = (options) => initUnconfiguredForSearchResults({ ...options }, $, $.post);
const initComparedForMapCard = (options) => initUnconfiguredForSearchResults({ disableFlyingIcon: true, ...options }, $, $.post);
const unitCompareToggleButton = (options) => initUnconfiguredForSearchResults({ onlyButtonClick: true, toggleUnitFomComparedBtn: '.compareBtn', ...options }, $, $.post);
const updateCompareView = (options) => unconfiguredUpdateCompareView(options, $);

export {
    initComparedForSearchResults,
    unitCompareToggleButton,
    initComparedForMapCard,
    initUnconfiguredForSearchResults,
    unconfiguredUpdateCompareView,
    updateCompareView,
};
